@use "styles/mixins/_fonts.scss" as fonts;

.image-placeholder {
  border-radius: var(--size-border-radius-m);
  border: 1px solid var(--color-border-subtle);
  background-color: var(--color-background-subtle);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--size-spacing-l);
  padding: var(--size-spacing-2xl);

  &-text {
    @include fonts.body-accent-xs;

    text-align: center;
  }
}

.image-credit-text {
  @include fonts.body-accent-s;

  color: var(--color-text-disabled);
  margin-right: var(--size-spacing-s);
}
